import { Box, Drawer, Menu, styled, Toolbar } from '@mui/material';

export const MobileToolbar = styled(Toolbar)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.border.main}`,
  marginBottom: theme.spacing(2),
  width: '100%',
}));

export const NavbarContainer = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  borderBottom: `1px solid ${theme.palette.gray.light}`,
  boxShadow: '0 4px 4px 0 rgba(99, 108, 123, 0.09);',
  display: 'flex',
  height: theme.spacing(9),
  justifyContent: 'space-between',
  padding: `0px ${theme.spacing(4)}`,
}));

export const PageContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const StyledMenu = styled(Menu)(() => ({
  '& .MuiPaper-root': {
    minWidth: '200px',
  },
}));

export const TabDrawer = styled(Drawer)(() => ({
  width: '100%',
  '.MuiPaper-root': {
    width: '70%',
  },
}));
